import '../../styles/Table.css';

function __numberToFloat(num) {
    return parseFloat(num).toFixed(1);
}

function formatDateTime(dateTime) {
    const date      = new Date(dateTime);
    const day       = `0${date.getDate()}`.slice(-2);
    const month     = `0${date.getMonth() + 1}`.slice(-2);
    const year      = date.getFullYear();
    const hours     = `0${date.getHours()}`.slice(-2);
    const minutes   = `0${date.getMinutes()}`.slice(-2);

    return `${day}/${month}/${year} às ${hours}:${minutes}`;
}


function InputFileTable({ tableData, handleRowCLick }) {
    return (
        <>
            <h2 className="pt-[15px]">Demandas Filtradas</h2>

            <table className='table-pattern-sistem w-full borda-cinza mt-4'>
                
                <thead className='bg-neutro'>
                    <tr>
                        <th>ID</th>
                        <th>Tipo</th>
                        <th>Versão</th>
                        <th>Usuário</th>
                        <th>Ferrovia</th>
                        <th>Postado em</th>
                        <th>Status</th>
                    </tr>
                </thead>

                <tbody>
                    
                    {Array.isArray(tableData) && tableData.length > 0 ? (
                    
                    tableData.map((row) => (
                        
                        <tr className='row hover:cursor-pointer hover:bg-neutro' 
                            onClick={() => handleRowCLick(row.id)} key={row.id}>
                            
                            <td>{row.id}</td>
                            <td>{row.ownerDemandHorizon.ownerHorizonOfPlan.name}</td>
                            <td>{__numberToFloat(row.version)}</td>
                            <td>{row.ownerAuthor.fullName}</td>
                            <td>{row.ownerDemandRailway.name}</td>
                            <td>{formatDateTime(row.createdAt)}</td>
                            <td dangerouslySetInnerHTML={{ __html: row.ownerDemandPostStatus.icon }}></td>

                        </tr>

                    ))

                    ) : (
                        <tr>
                            <td colSpan="7" className="text-center p-4">
                                Nenhum dado encontrado.
                            </td>
                        </tr>
                    )}
                </tbody>
                
            </table>

        </>
    );
}

export default InputFileTable;
